import { render, staticRenderFns } from "./StudentActivityTableStudentCell.vue?vue&type=template&id=1707c2de&scoped=true&"
import script from "./StudentActivityTableStudentCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableStudentCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableStudentCell.vue?vue&type=style&index=0&id=1707c2de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707c2de",
  null
  
)

export default component.exports